import styled from "styled-components";

export const PatientSearchContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  max-height: 100%;
`;
